<script setup>
import { format } from 'date-fns'
import { it } from 'date-fns/locale'

defineProps({
  notizie: {
    type: Object,
    default: () => ({}),
  },
})

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

const formatDate = (dateString) => {
  const date = new Date(dateString)
  const formattedDate = format(date, 'd MMMM yyyy', { locale: it })
  const parts = formattedDate.split(' ')
  parts[1] = capitalizeFirstLetter(parts[1])
  return parts.join(' ')
}
</script>

<template>
  <div class="notizie-listing p-top-xxl-b p-bottom-xl-1">
    <div class="container">
      <!-- eslint-disable vue/no-v-html -->
      <div class="grid">
        <div v-for="notizia in notizie" :key="notizia.index" class="grid-item">
          <div class="image">
            <nuxt-link
              :to="
                localePath({
                  name: 'notizie-slug',
                  params: { slug: notizia.slug },
                })
              "
            >
              <DefaultPicture
                :image="{
                  custom: notizia.landscape.responsiveImage,
                }"
                :lazy-load="true"
                alt="Istituto Canossiano"
              />
            </nuxt-link>
          </div>
          <div class="text-section underline-animation">
            <div v-if="notizia.data" class="text-xs-1">
              {{ formatDate(notizia.data) }}
            </div>
            <h3>
              <nuxt-link
                :to="
                  localePath({
                    name: 'notizie-slug',
                    params: { slug: notizia.slug },
                  })
                "
              >
                <span class="title text-1" v-html="notizia.titolo" />
              </nuxt-link>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotizieListing',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
